// extracted by mini-css-extract-plugin
module.exports = {"segment":"PerspectiveModule_segment__3ixEx","miniDocLink":"PerspectiveModule_miniDocLink__gCcjN","miniDoc":"PerspectiveModule_miniDoc__NSdEq"};